// extracted by mini-css-extract-plugin
module.exports = {"sp7qdyr":"sp7qdyr"};